/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useEffect, useState } from 'react';
import { theme } from '../../config';
import { useSelector } from 'react-redux';
import { IAuthResponse, ILocationWide, ILocationWideResponse, IPagedLocationWideResponse } from './../../Interfaces';
import { DataGrid, GridColDef, GridColTypeDef, GridFilterItem, GridFilterModel, GridPaginationModel, GridRenderCellParams, GridRowClassNameParams, GridRowParams, GridSortItem, GridSortModel, GridValueFormatterParams,  getGridStringOperators } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { formattedDate, formattedDateTime } from '../../Helpers/TimeMethods';
import LoginForm from '../../Components/LoginForm';
import { Box, Pagination, ThemeProvider } from '@mui/material';
import { GetHistoryGridData } from '../../Data/ApiRequests';



const HistoryLocationList = ( ) => {
    const defaultPageSize = 25;
    const bearerToken:IAuthResponse  = useSelector( (state:IAuthResponse) => state)
    const navigate = useNavigate();
    const [historyData, setHistoryData] = useState<ILocationWide[]>([]);
    const [isLoaded,  setIsLoaded] = useState(false);
    const [errorLoad, setError] = useState('');
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(defaultPageSize);
    const [sortParams, setSortParams] = useState<GridSortItem[]>([])
    const [filterParams, setFilterParams] = useState<GridFilterItem[]>([])



    const fetchData = async (page: number, pageSize: number,  mySortParams: GridSortItem[], myFilterParams: GridFilterItem[]) => {
        // console.log('mySorsParams', mySortParams)
        GetHistoryGridData(bearerToken, page, pageSize, mySortParams, myFilterParams)
          .then(response => {
                const jsonData:IPagedLocationWideResponse = response;
                const objects: ILocationWide[] = []
                jsonData.locationWithRoomspaces.map( (x:ILocationWideResponse) => {
                  objects.push( {
                    id: x.location.id  + ' ' + x.roomspace.roomspaceId,
                    wnummer: x.location.wnummer,
                    name: x.location.name,
                    capacity: x.location.capacity,
                    locationCategory: x.location.locationCategory,
                    district: x.location.district,
                    residentGroups: x.location.residentGroups,
                    address: x.location.address,
                    applicationUserId: x.location.applicationUserId,
                    userLocationPermissions: x.location.userLocationPermissions,
                    startOfOccupancy: x.location.startOfOccupancy,
                    endOfOccupancy: x.location.endOfOccupancy,
                    lastUpdate: (x.roomspace?.lastUpdate !== undefined) ? x.roomspace.lastUpdate : new Date(0),
                    lastEditBy: (x.roomspace.lastEditBy !== undefined) ? x.roomspace.lastEditBy : '',
                    numberOfUnoccupiedSeats: (x.roomspace?.numberOfUnoccupiedSeats !== undefined) ? x.roomspace?.numberOfOccupiedUkr : 0,
                    numberOfOccupiedUkr: (x.roomspace?.numberOfOccupiedUkr !== undefined) ? x.roomspace?.numberOfOccupiedUkr : 0,
                    numberOfOccupiedOru: (x.roomspace?.numberOfOccupiedOru !== undefined) ? x.roomspace?.numberOfOccupiedOru : 0,
                    numberOfAvailablePlaces: (x.roomspace?.numberOfAvailablePlaces !== undefined) ? x.roomspace?.numberOfAvailablePlaces : 0,
                    numberOfReservedSeats: (x.roomspace?.numberOfReservedSeats !== undefined) ? x.roomspace?.numberOfReservedSeats : 0,
                    whyNotAssignable: (x.roomspace?.whyNotAssignable  !== undefined) ? x.roomspace?.whyNotAssignable  : '',
                    //singleRoomW: (x.roomspace?.singleRoomW !== undefined) ? x.roomspace?.singleRoomW : 0,
                    //singleRoomM: (x.roomspace?.singleRoomM !== undefined) ? x.roomspace?.singleRoomM : 0,
                    singleRoomFMD: (x.roomspace?.singleRoomFMD !== undefined) ? x.roomspace?.singleRoomFMD : 0,
                    feedSlotW: (x.roomspace?.feedSlotW !== undefined) ? x.roomspace?.feedSlotW : 0,
                    feedSlotM: (x.roomspace?.feedSlotM !== undefined) ? x.roomspace?.feedSlotM : 0,
                    roomForTwo: (x.roomspace?.roomForTwo !== undefined) ? x.roomspace?.roomForTwo : 0,
                    roomForThree: (x.roomspace?.roomForThree !== undefined) ? x.roomspace?.roomForThree: 0,
                    roomForFour: (x.roomspace?.roomForFour !== undefined) ? x.roomspace?.roomForFour: 0,
                    roomForFive: (x.roomspace?.roomForFive !== undefined) ? x.roomspace?.roomForFive: 0,
                    roomForSix: (x.roomspace?.roomForSix !== undefined) ? x.roomspace?.roomForSix: 0,
                    roomForSeven: (x.roomspace?.roomForSeven !== undefined) ? x.roomspace?.roomForSeven: 0,
                    roomForEight: (x.roomspace?.roomForEight !== undefined) ? x.roomspace?.roomForEight: 0,
                    roomForNine: (x.roomspace?.roomForNine !== undefined) ? x.roomspace?.roomForNine: 0,
                    roomForTen: (x.roomspace?.roomForTen !== undefined) ? x.roomspace?.roomForTen: 0,
                    totalSeats: 0,
                    seatsQuantityChanged: (x.roomspace?.seatsQuantityChanged !== undefined) ? x.roomspace?.seatsQuantityChanged: 0,


                    text_FeedSlotM: (x.roomspace?.text_FeedSlotM !== undefined) ? x.roomspace?.text_FeedSlotM: '',
                    text_FeedSlotW: (x.roomspace?.text_FeedSlotW !== undefined) ? x.roomspace?.text_FeedSlotW: '',
                    //text_SingleRoomM: (x.roomspace?.text_SingleRoomM !== undefined) ? x.roomspace?.text_SingleRoomM: '',
                    //text_SingleRoomW: (x.roomspace?.text_SingleRoomW !== undefined) ? x.roomspace?.text_SingleRoomW: '',
                    text_SingleRoomFMD: (x.roomspace?.text_SingleRoomFMD !== undefined) ? x.roomspace?.text_SingleRoomFMD: '',
                    text_RoomForTwo: (x.roomspace?.text_RoomForTwo !== undefined) ? x.roomspace?.text_RoomForTwo: '',
                    text_RoomForThree: (x.roomspace?.text_RoomForThree !== undefined) ? x.roomspace?.text_RoomForThree: '',
                    text_RoomForFour: (x.roomspace?.text_RoomForFour !== undefined) ? x.roomspace?.text_RoomForFour: '',
                    text_RoomForFive: (x.roomspace?.text_RoomForFive !== undefined) ? x.roomspace?.text_RoomForFive: '',
                    text_RoomForSix: (x.roomspace?.text_RoomForSix !== undefined) ? x.roomspace?.text_RoomForSix: '',
                    text_RoomForSeven: (x.roomspace?.text_RoomForSeven !== undefined) ? x.roomspace?.text_RoomForSeven: '',
                    text_RoomForEight: (x.roomspace?.text_RoomForEight !== undefined) ? x.roomspace?.text_RoomForEight: '',
                    text_RoomForNine: (x.roomspace?.text_RoomForNine !== undefined) ? x.roomspace?.text_RoomForNine: '',
                    text_RoomForTen: (x.roomspace?.text_RoomForTen !== undefined) ? x.roomspace?.text_RoomForTen: '',
                    allRoomsComments: `${x.roomspace?.text_FeedSlotM || ''}
    ${x.roomspace?.text_FeedSlotW || ''}
    ${x.roomspace?.text_SingleRoomFMD || ''}
    ${x.roomspace?.text_RoomForTwo || ''}
    ${x.roomspace?.text_RoomForThree || ''}
    ${x.roomspace?.text_RoomForFour || ''}
    ${x.roomspace?.text_RoomForFive || ''}
    ${x.roomspace?.text_RoomForSix || ''}
    ${x.roomspace?.text_RoomForSeven || ''}
    ${x.roomspace?.text_RoomForEight || ''}
    ${x.roomspace?.text_RoomForNine || ''}
    ${x.roomspace?.text_RoomForTen || ''}`

                    }
                  )
                })
                setHistoryData(objects)
                setTotalRows(jsonData.totalItems)
                // setCurrentPage(jsonData.currentPage)
                setIsLoaded(true)

          }).catch( error => {
            console.error('Error fetching data:', error);
            setError('Error fetching data:' + error)
            setIsLoaded(true);
          })
      };

      useEffect(() => {

        if(bearerToken.token === '') {
          setError('You are not authorised');
         }
         else {
           fetchData(currentPage, currentPageSize, sortParams, filterParams);
         }
      }, [bearerToken.token]);


  const startOfOccupancyColumn: GridColTypeDef = {
    type: 'date',
    headerName: 'Belegungsstart',
    width: 120,
    valueFormatter: (params: GridValueFormatterParams<Date>) => {
      if (params.value == null) {
        return '';
      }
      return formattedDate( params.value)
    }
  };

  const endOfOccupancyColumn: GridColTypeDef = {
    type: 'date',
    headerName: 'Belegungsende',
    width: 120,
    valueFormatter: (params: GridValueFormatterParams<Date>) => {
      if (params.value == null) {
        return '';
      }
      return formattedDate( params.value)
    }
  };

  const lastUpdateColumn: GridColTypeDef = {
    type: 'date',
    headerName: 'Letzte Meldung vom',
    width: 150,

    valueFormatter: (params: GridValueFormatterParams<Date>) => {
      if (params.value == null) {
        return '';
      }
      if (typeof params.value === 'object')  return '- ';
      return formattedDateTime( params.value)

    }
  };

  const filterOperators = getGridStringOperators().filter(
    (operator) => operator.value === 'equals' ,
  );

  // const numericFilterOperators = [
  //   ...getGridNumericOperators(),
  // ]

  const columns: GridColDef[] = [
    { field: 'wnummer', headerName: 'Leitzeichen', width: 150, flex: 0 , type: 'string', sortable: true, filterable: true , filterOperators: filterOperators},
    { field: 'name', headerName: 'Name des Standortes', width: 140, flex: 0, type: 'string', sortable: true,
    filterable: true, filterOperators: filterOperators},
    { field: 'locationCategory', headerName: 'Standortkategorie', width: 120, flex: 0, sortable: false, filterable: false },
    // { field: 'district', headerName: 'Bezirk', width: 150, flex: 0  },
    // { field: 'address', headerName: 'Adresse', width: 150, flex: 0  },
    // { field: 'email', headerName: 'E-Mail', width: 150 , hideable: true, flex: 0 },
    // { field: 'telefon', headerName: 'Telefon', width: 150 , flex: 0 },
    { field: 'startOfOccupancy', ...startOfOccupancyColumn , flex: 0, sortable: false, filterable: false  },
    { field: 'endOfOccupancy', ...endOfOccupancyColumn , flex: 0, sortable: false, filterable: false  },
    { field: 'lastUpdate', ...lastUpdateColumn , flex: 0, type: 'dateTime', sortable: true, filterable: false },
    { field: 'capacity', headerName: 'Soll-Kapazität', width: 120 , flex: 0 , sortable: false, filterable: false },
    { field: 'numberOfOccupiedOru', headerName: 'Ist-Belegung Andere', width: 120, flex: 0 , sortable: false, filterable: false },
    { field: 'numberOfOccupiedUkr', headerName: 'Ist-Belegung Ukraine-Geflüchtete', width: 120, flex: 0 , sortable: false, filterable: false },
    { field: 'numberOfAvailablePlaces', headerName: 'Anzahl freier Plätze', width: 120, flex: 0, sortable: false,
      filterable: false },
      
      
      { field: 'numberOfReservedSeats', headerName: 'Anzahl reservierter Plätze', width: 120, flex: 0, sortable: false, filterable: false, type: 'number', align: 'left',
      },

    { field: 'numberOfUnoccupiedSeats', headerName: 'Anzahl nicht belegbare Plätze', width: 120, flex: 0 , sortable: false, filterable: false },
    { field: 'whyNotAssignable', headerName: 'warum nicht belegbar?', width: 150 , flex: 0, sortable: false, filterable: false },
    //{ field: 'singleRoomW', headerName: 'alleinstehende Frauen', width: 120, flex: 0, sortable: false, filterable: false },
    //{ field: 'singleRoomM', headerName: 'alleinstehende Männer', width: 120, flex: 0, sortable: false, filterable: false },
    { field: 'singleRoomFMD', headerName: 'alleinstehende', width: 120, flex: 0, sortable: false, filterable: false },
    {
      field: 'text_FeedSlotW', headerName: 'Anmerkungen zur alleinstehende',
      minWidth: 140, flex: 0, sortable: false, filterable: false,
      type: 'string', align: 'left', resizable: true,
      renderCell: (params: GridRenderCellParams<any>) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
      ),
    },

    { field: 'roomForTwo', headerName: '2er', width: 100, flex: 0, sortable: false, filterable: false },
    {
      field: 'text_RoomForTwo', headerName: 'Anmerkungen zur 2er',
      minWidth: 140, flex: 0, sortable: false, filterable: false,
      type: 'string', align: 'left', resizable: true,
      renderCell: (params: GridRenderCellParams<any>) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
      ),
    },
    { field: 'roomForThree', headerName: '3er', width: 100, flex: 0, sortable: false, filterable: false },
    {
      field: 'text_RoomForThree', headerName: 'Anmerkungen zur 3er',
      minWidth: 140, flex: 0, sortable: false, filterable: false,
      type: 'string', align: 'left', resizable: true,
      renderCell: (params: GridRenderCellParams<any>) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
      ),
    },
    { field: 'roomForFour', headerName: '4er', width: 100, flex: 0, sortable: false, filterable: false },
    {
      field: 'text_RoomForFour', headerName: 'Anmerkungen zur 4er',
      minWidth: 140, flex: 0, sortable: false, filterable: false,
      type: 'string', align: 'left', resizable: true,
      renderCell: (params: GridRenderCellParams<any>) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
      ),
    },
    { field: 'roomForFive', headerName: '5er', width: 100, flex: 0, sortable: false, filterable: false },

    {
      field: 'text_RoomForFive', headerName: 'Anmerkungen zur 5er',
      minWidth: 140, flex: 0, sortable: false, filterable: false,
      type: 'string', align: 'left', resizable: true,
      renderCell: (params: GridRenderCellParams<any>) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
      ),
    },

    { field: 'roomForSix', headerName: '6er', width: 100, flex: 0, sortable: false, filterable: false },
    {
      field: 'text_RoomForSix', headerName: 'Anmerkungen zur 6er',
      minWidth: 140, flex: 0, sortable: false, filterable: false,
      type: 'string', align: 'left', resizable: true,
      renderCell: (params: GridRenderCellParams<any>) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
      ),
    },
    { field: 'roomForSeven', headerName: '7er', width: 100, flex: 0, sortable: false, filterable: false },
    {
      field: 'text_RoomForSeven', headerName: 'Anmerkungen zur 7er',
      minWidth: 140, flex: 0, sortable: false, filterable: false,
      type: 'string', align: 'left', resizable: true,
      renderCell: (params: GridRenderCellParams<any>) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
      ),
    },
    { field: 'roomForEight', headerName: '8er', width: 100, flex: 0, sortable: false, filterable: false },
    {
      field: 'text_RoomForEight', headerName: 'Anmerkungen zur 8er',
      minWidth: 140, flex: 0, sortable: false, filterable: false,
      type: 'string', align: 'left', resizable: true,
      renderCell: (params: GridRenderCellParams<any>) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
      ),
    },
    { field: 'roomForNine', headerName: '9er', width: 100, flex: 0, sortable: false, filterable: false },
    {
      field: 'text_RoomForNine', headerName: 'Anmerkungen zur 9er',
      minWidth: 140, flex: 0, sortable: false, filterable: false,
      type: 'string', align: 'left', resizable: true,
      renderCell: (params: GridRenderCellParams<any>) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
      ),
    },

    { field: 'roomForTen', headerName: '10er', width: 100, flex: 0, sortable: false, filterable: false },
    {
      field: 'text_RoomForTen', headerName: 'Anmerkungen zur 10er',
      minWidth: 140, flex: 0, sortable: false, filterable: false,
      type: 'string', align: 'left', resizable: true,
      renderCell: (params: GridRenderCellParams<any>) => (
        <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
      ),
    },
    { field: 'allRoomsComments', headerName: 'Anmerkungen zu Plätzen', sortable: false, filterable: false },
    { field: 'lastEditBy', headerName: 'edited By', sortable: false, filterable: false }

  ];

/* eslint-disable  @typescript-eslint/no-explicit-any */
  const getRowClassName = (params: GridRowClassNameParams<any>) => {
    return (params.indexRelativeToCurrentPage % 2 === 0) ? 'stripeOdd' : 'stripeEven'
  };

    function selectGridRow(params: GridRowParams<any>): void {
        navigate("/locations/" + params.row.wnummer)
    }


  function filtersApply(model: GridFilterModel): void {
    setFilterParams(model.items)
    fetchData(1, defaultPageSize, sortParams, model.items )
  }

    function SortModelChanged(model: GridSortModel): void {
        setHistoryData([])
        setSortParams(model)
        fetchData(currentPage, currentPageSize, model, filterParams)
    }

  function paginationModelChange(model: GridPaginationModel): void {
    setHistoryData([])
    const fixPageNumber = model.page + 1
    setCurrentPage(fixPageNumber)
    setCurrentPageSize(model.pageSize)
    fetchData(fixPageNumber,  model.pageSize, sortParams, filterParams)
  }

    return (
        <div>


            {
                (!bearerToken.isLoggedIn) && <Box sx={{p: 1, m: 1}}><LoginForm /></Box>
            }

            {
                (!isLoaded && bearerToken.role === 'Admin') && <div>Loading ...</div>
            }



            {
              (bearerToken.isLoggedIn && (bearerToken.role === 'Admin' || bearerToken.role === 'User') ) &&
              <>

              <h2>Standorte Geschichte</h2>
            <div style={{ width: 'calc(100%-50px)', overflow: 'none' }}>
            { errorLoad }

            {
              errorLoad === '' &&
              <ThemeProvider theme={theme}>

              <DataGrid
              initialState={{
                sorting: {
                  sortModel: [{ field: 'lastUpdate', sort: 'desc' }],
                },
                pagination: {   paginationModel: { pageSize: defaultPageSize, page: currentPage } },
              }}
              rows={historyData}
              columns={columns}

              onRowClick={selectGridRow}
              onFilterModelChange={ filtersApply }
              scrollbarSize={0} style={{margin: 0}}

              pageSizeOptions={[5, 10, 25]}

              paginationMode='server'
              sortingMode='server'
              filterMode='server'
              rowCount={totalRows}
              onPaginationModelChange={ paginationModelChange }
              onSortModelChange={ SortModelChanged }
              pagination={true}
              hideFooter={false}
              showCellVerticalBorder
                  sx={{ padding: 0, margin: 0, fontSize: 13,
                    "& .MuiDataGrid-columnHeaderTitle": {
                      whiteSpace: "normal",
                      lineHeight: "normal", fontSize: 12
                    },
                  }}
                  getRowId={(row: any) => row.id}
                  getRowClassName={getRowClassName}
                />

                  <Pagination  />

                 </ThemeProvider>
            }

            </div>
                </>
            }



{/* {
  bearerToken.isLoggedIn &&  <TheLegend />
} */}

        </div>
    );
};

export default HistoryLocationList;
